import {popup_action} from "../actions/popup";


const inited = {
    display: false,
    code: null,
    data: null
};

export default function popupReducer(state = inited, action) {
    switch (action.type) {
        case popup_action:
            return {
                ...state,
                ...(action.hasOwnProperty('payload') ? action.payload : inited)
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/libs/redux/reducres/popup.js